module.exports = __webpack_public_path__ + "static/media/android-studio.959ec895.jfif";